<template>
  <div class="body">
    <div class="title">
      活动管理
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }" class="dsadf">
            <span class="dsadf">首页</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>发布管理</el-breadcrumb-item>
          <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
        <!-- <el-button type="primary" icon="el-icon-plus" size="medium" @click="fabuhuodongguanli">发布</el-button> -->
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="medium"
          @click="releaseActivity"
          v-if="true || seeTest"
          >发布</el-button
        >
      </div>
      <div class="csass"></div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item v-if="type == 0">
            <el-cascader
              v-model="areaArray"
              :props="checkedData.typeOptions"
              @change="handleCascaderChange"
              placeholder="区域选择"
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              @change="Discountsearch"
              v-model="Query.create_date"
              placeholder="发布日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              placeholder="活动状态"
              v-model="Query.act_status"
              @change="Discountsearch"
              style="min-width: 168px; width: 168px"
              clearable
            >
              <el-option
                v-for="item in act_status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="排序/跳转链接/链接说明 "
              v-model="Query.keyword"
              @input="Discountsearch"
              style="min-width: 168px; width: 336px"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      border
      keep-source
      ref="xTable"
      max-height="750"
      class="mytable-scrollbar"
      :data="tableData"
      align="center"
      :edit-config="{
        trigger: 'click',
        mode: 'cell',
        icon: 'fa fa-pencil',
        showStatus: true,
      }"
    >
      <!-- <vxe-table-column type="seq" width="60"></vxe-table-column> -->
      <vxe-table-column field="id" title="ID" width="60"></vxe-table-column>
      <vxe-table-column
        field="name"
        title="活动标题"
        minWidth="220"
      ></vxe-table-column>
      <vxe-table-column field="huodongshijian" title="活动时间" width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.act_starttime }}-</div>
          <div>{{ scope.row.act_endtime }}</div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="address" title="活动地址" width="200">
      </vxe-table-column>
      <vxe-table-column field="type" title="活动类型" width="120">
        <template slot-scope="scope">
          <div>{{ getActivityType(scope.row.type) }}</div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="huodongzhuangtai" title="活动审核" width="100">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.is_status === 0">草稿</el-tag>
          <el-tag size="mini" type="danger" v-if="scope.row.is_status === 1"
            >待审核</el-tag
          >
          <el-tag
            size="mini"
            type="success"
            v-else-if="scope.row.is_status === 2"
            >审核通过</el-tag
          >
          <el-tag size="mini" type="danger" v-if="scope.row.is_status === 3"
            >审核驳回</el-tag
          >
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="enrollnum"
        title="报名人数"
        width="80"
      ></vxe-table-column>
      <vxe-table-column field="huodongzhuangtai" title="活动状态" width="100">
        <template slot-scope="scope">
          <el-tag size="mini" type="success" v-if="scope.row.act_status == 1">{{
            scope.row.act_status_text
          }}</el-tag>
          <el-tag
            size="mini"
            type="warning"
            v-else-if="scope.row.act_status == 0"
            >{{ scope.row.act_status_text }}</el-tag
          >
          <el-tag
            size="mini"
            type="warning"
            v-else-if="scope.row.act_status == 2"
            >{{ scope.row.act_status_text }}
          </el-tag>
          <el-tag
            size="mini"
            type="warning"
            v-else-if="scope.row.act_status == 5"
            >{{ scope.row.act_status_text }}
          </el-tag>
          <el-tag
            size="mini"
            type="danger"
            v-else-if="scope.row.act_status == 3"
            >{{ scope.row.act_status_text }}
          </el-tag>
          <el-tag
            size="mini"
            type="danger"
            v-else-if="scope.row.act_status == 4"
            >{{ scope.row.act_status_text }}
          </el-tag>
        </template>
      </vxe-table-column>
      <vxe-table-column field="sport_type_text" title="活动类型" width="100">
        <template slot-scope="scope" v-if="scope.row.sport_type_text">
          {{ scope.row.sport_type_text }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="enroll_starttime" title="报名时间" width="200">
        <template slot-scope="scope" v-if="scope.row.enroll_starttime">
          {{ scope.row.enroll_starttime }} - {{ scope.row.enroll_endtime }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="org_com"
        title="发布人"
        width="200"
      ></vxe-table-column>

      <vxe-table-column field="createtime" title="发布时间" width="200">
        <template slot-scope="scope">
          {{ scope.row.createtime }}
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="290">
        <!-- :min-width="type !== 2 ? 700 : 550" -->
        <template slot-scope="scope">
          <el-button
            type="primary"
            class="bianji"
            size="mini"
            @click="handleEditActivity(scope.row)"
            v-if="true || seeTest"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.is_status !== 0"
            size="mini"
            @click="xiaochengxuma(scope.row)"
            class="bianji"
          >
            小程序码
          </el-button>
          <el-dropdown>
            <el-button
              type="primary"
              size="mini"
              class="bianji"
              style="margin-left: 10px"
            >
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  v-if="scope.row.is_status !== 0"
                  size="mini"
                  @click="chengjiguanli(scope.row)"
                  class="bianji"
                >
                  成绩管理
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  v-if="scope.row.is_status !== 0"
                  size="mini"
                  @click="baomingjilu(scope.row)"
                  class="bianji"
                >
                  报名记录
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  v-if="scope.row.signin_type.indexOf('2') > -1"
                  size="mini"
                  @click="xiaochengxuqiandaoma(scope.row)"
                  class="bianji"
                >
                  签到码
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="warn"
                  v-if="scope.row.is_status === 1 && type !== 2"
                  size="mini"
                  @click="shenhetongguo(scope.row)"
                >
                  审核通过
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="danger"
                  v-if="scope.row.is_status === 1 && type !== 2"
                  size="mini"
                  @click="shenhebutongguo(scope.row)"
                  class="bianji red"
                >
                  审核不通过
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  size="mini"
                  @click="handleCopy(scope.row)"
                  class="bianji"
                >
                  复制草稿
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  size="mini"
                  @click="shanchu(scope.row)"
                  class="bianji"
                >
                  删除
                </el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button v-if="scope.row.is_status !== 0" size="mini" @click="chengjiguanli(scope.row)" class="bianji">
                        成绩管理
                    </el-button>
                    <el-button v-if="scope.row.is_status !== 0" size="mini" @click="baomingjilu(scope.row)" class="bianji">
                        报名记录
                    </el-button>

                    <el-button v-if="scope.row.signin_type.indexOf('2') > -1" size="mini" @click="xiaochengxuqiandaoma(scope.row)" class="bianji">
                        签到码
                    </el-button>
                    <el-button v-if="scope.row.is_status === 1 && type !== 2" size="mini" @click="shenhetongguo(scope.row)" class="bianji">
                        审核通过
                    </el-button>
                    <el-button v-if="scope.row.is_status === 1 && type !== 2" size="mini" @click="shenhebutongguo(scope.row)" class="bianji red" type="danger">
                        审核不通过
                    </el-button>
                    <el-button size="mini" @click="shanchu(scope.row)" class="bianji">
                        删除
                    </el-button> -->
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10, 15, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <Chengjiguanli ref="Chengjiguanli" />
    <Baomingjilu ref="Baomingjilu" />
    <Xiaochengxuma ref="Xiaochengxuma" />
    <XiaochengxuQiandaoma ref="XiaochengxuQiandaoma" />
  </div>
</template>

<script>
import Chengjiguanli from "./components/Chengjiguanli";
import Baomingjilu from "./components/Baomingjilu";
import Xiaochengxuma from "./components/Xiaochengxuma";
import XiaochengxuQiandaoma from "./components/XiaochengxuQiandaoma";
import { getWzArea } from "@/api/city";

import {
  actList,
  businessassociationDel,
  huoDongSetstatusval,
  activityCopy,
} from "@/api/tiezi";

import {
  ACTIVITY_WAY,
} from "@/views/activities/constant";

import { adminInfo } from "@/api/login";

export default {
  name: "index",
  components: {
    Chengjiguanli,
    Baomingjilu,
    Xiaochengxuma,
    XiaochengxuQiandaoma,
  },
  data() {
    return {
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad,
        },
      },
      areaArray: [],
      type: 2,
      user_name: "",
      tableData: [],
      Query: {
        token: sessionStorage.getItem("token"),
        create_date: "",
        space: "",
        act_status: null,
        keyword: "",
        page: 1,
        pagesize: 10,
        // is_status: 0,
      },
      total: null,
      pageshow: true,
      cur_page: 1,
      typeList: [
        {
          label: "跑步",
          value: "1",
        },
        {
          label: "篮球",
          value: "2",
        },
        {
          label: "羽毛球",
          value: "3",
        },
        {
          label: "乒乓球",
          value: "4",
        },
        {
          label: "足球",
          value: "5",
        },
        {
          label: "游泳",
          value: "6",
        },
        {
          label: "篮球",
          value: "7",
        },
        {
          label: "党建活动",
          value: "10",
        },
        {
          label: "马拉松",
          value: "11",
        },
        {
          label: "其他",
          value: "8",
        },
      ],
      act_status: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "报名未开始",
          value: "0",
        },
        {
          label: "报名进行中",
          value: "1",
        },
        {
          label: "报名已结束",
          value: "2",
        },
        {
          label: "活动已报满",
          value: "3",
        },
        {
          label: "活动进行中",
          value: "4",
        },
        {
          label: "活动已结束",
          value: "5",
        },
      ],
    };
  },
  computed: {
    seeTest() {
      return (
        this.user_name === "zcx" ||
        this.user_name === "test" ||
        this.user_name === "wzsyyxh"
      );
    },
  },
  created() {
    this.getUserInfo();
    this.xiangqing();
  },
  methods: {
    getActivityType(type) {
      return ACTIVITY_WAY.find((item) => item.value == type)?.label || "其他";
    },
    handleCopy(item) {
      console.log("_handleCopy", item.id);
      activityCopy({ id: item.id }).then((resp) => {
        this.$notify({
          title: "温馨提示",
          message: resp.data.msg,
          type: "success",
        });
        if (resp.data.result === 1) {
          this.xiangqing();
        }
      });
    },
    releaseActivity() {
      this.$router.push("/activity-release");
    },
    handleEditActivity(row) {
      console.log("_handleEditActivity", row);
      this.$router.push(`/activity-release?id=${row.id}`);
    },
    handleCascaderChange(val) {
      console.log("handleCascaderChange", val);
      this.Query.area_id = val[0];
      this.Query.town_id = val[1] || "";
      this.xiangqing();
    },
    async lazyLoad(node, resolve) {
      const level = node.level;
      let result;
      let res;
      let param;
      switch (level) {
        case 0: // 一级
          res = await getWzArea();
          result = res.data.data;
          result.forEach((item) => {
            // console.log("item", item)
            item.value = item.code;
            item.label = item.name;
            item.leaf =
              item.code === "330300000000" || item.code === "100000000000";
          });
          break;
        case 1: // 二级
          param = {
            code: node.data.code,
            pid: node.data.id,
          };
          res = await getWzArea(param);
          result = res.data.data;
          // console.log('_', result);
          result.unshift({
            value: "all",
            label: "全部",
            name: "全部",
            code: "0",
            leaf: true,
          });
          result.forEach((item) => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = level >= 1;
          });
          break;

        default:
          result = [];
          break;
      }
      resolve(result);
    },
    getUserInfo() {
      const obj = {
        token: sessionStorage.getItem("token"),
      };
      adminInfo(obj).then(({ data: res }) => {
        console.log("res", res);
        this.type = res.type;
        this.user_name = res.user_name;
      });
    },
    shanchu(item) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const obj = {
            token: sessionStorage.getItem("token"),
            id: item.id,
          };
          businessassociationDel(obj).then(({ data: res }) => {
            console.log("res", res);
            if (res.result === -1) {
              this.$message({
                message: res.msg,
                type: "error",
                duration: "2000",
              });
              setTimeout(() => {
                window.sessionStorage.clear();
                this.$router.push("/login");
              }, 1000);
            }
            if (res.result === 0) {
              this.$message({
                message: res.msg,
                type: "error",
                duration: "2000",
              });
              return false;
            }
            if (res.result === 1) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: "2000",
              });
              this.xiangqing();
            }
          });
        })
        .catch(() => {});
    },
    Discountsearch() {
      this.cur_page = 1;
      this.xiangqing();
      this.pageshow = false; // 让分页隐藏
      this.$nextTick(() => {
        // 重新渲染分页
        this.pageshow = true;
      });
    },
    handleSizeChange(val) {
      this.Query.pagesize = val;
      this.handleCurrentChange(this.Query.page);
    },
    handleCurrentChange(val) {
      this.Query.page = val;
      actList(this.Query).then(({ data: res }) => {
        console.log("res", res);
        this.tableData = res.list;
        this.total = res.total;
        this.tableData.forEach((i) => {
          i.area_address = i.area_name + i.town_name || "";
          i.huodongshijian = i.act_starttime + "---" + i.act_endtime;
        });
      });
    },
    xiangqing() {
      // 级联选择参数处理
      const query = this.Query;
      if (query.town_id && query.town_id !== "0") {
        //  选择二级并且未选中全部
        delete query.area_id;
      }
      if (query.town_id === "0" || !query.town_id) {
        // 选择二级选择全部, 传递一级code; 没有值
        delete query.town_id;
      }
      console.log("_query", query);

      actList(query).then(({ data: res }) => {
        console.log("res", res);
        this.tableData = res.list;
        this.total = res.total;
        this.tableData.forEach((i) => {
          i.area_address = i.area_name + i.town_name || "";
          i.huodongshijian = i.act_starttime + i.act_endtime;
        });
      });
    },
    fabuhuodongguanli() {
      this.$router.push("/fabuhuodongguanli");
    },
    chakanxiangqing(row) {
      // this.$store.commit("sethuodongID", row.id);
      this.$router.push("/huodongguanlichakanxiangqing?id=" + row.id);
    },
    chengjiguanli(row) {
      this.$refs.Chengjiguanli.handleOpenDialog(row);
    },
    baomingjilu(row) {
      this.$refs.Baomingjilu.handleOpenDialog(row);
    },
    xiaochengxuma(row) {
      this.$refs.Xiaochengxuma.handleOpenDialog(row);
    },
    xiaochengxuqiandaoma(row) {
      this.$refs.XiaochengxuQiandaoma.handleOpenDialog(row);
    },
    shenhetongguo(row) {
      this.$confirm("确认审核通过这条活动吗?", "审核通过", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          huoDongSetstatusval({
            token: sessionStorage.getItem("token"),
            id: row.id,
            is_status: 2,
          }).then(({ data: res }) => {
            console.log("_shenhetongguo", res);
            if (res.result === 1) {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.xiangqing();
            } else {
              this.$message({
                type: "warn",
                message: "操作失败!",
              });
            }
          });
        })
        .catch(() => {});
    },
    shenhebutongguo(row) {
      this.$confirm("确认审核不通过这条活动吗?", "审核不通过", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          huoDongSetstatusval({
            token: sessionStorage.getItem("token"),
            id: row.id,
            is_status: 3,
          }).then(({ data: res }) => {
            console.log("_shenhebutongguo", res);
            if (res.result === 1) {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.xiangqing();
            } else {
              this.$message({
                type: "warn",
                message: "操作失败!",
              });
            }
          });
        })
        .catch(() => {});
    },

    getGroupName(list) {
      return list.map((item) => item.title).join(",");
    },
  },
};
</script>

<style scoped lang="less">
.bianji {
  // width: 78px;
  // height: 37px;
  opacity: 1;
  border: 1px solid rgba(61, 154, 255, 0.5);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #3d9aff;
  letter-spacing: 0px;
  background: white;
  margin-right: 2px;

  &.red {
    color: #f56c6c;
    border-color: #f56c6c;
  }
}

.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3d9aff;
    }
  }

  .btnsearch {
    display: flex;
    flex-direction: row;
    align-items: center;

    .left {
      margin-right: 150px;
    }

    .right {
      margin-top: 27px;
    }
  }
}
</style>
